import { EuiInputPopover, EuiSelectable } from "@inscopix/ideas-eui";
import { COUNTRIES, CountryCode } from "../constants/countries";
import { useState } from "react";
import { FormikErrors } from "formik";
import { PersonalSpaceFormFields } from "../FormCreatePersonalSpace";

interface CountrySelectableProps {
  value: CountryCode;
  handleBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  setFieldValue: (
    field: string,
    value: React.SetStateAction<CountryCode>,
    shouldValidate?: boolean,
  ) => Promise<void | FormikErrors<PersonalSpaceFormFields>>;
}

export const CountrySelectable = ({
  value,
  handleBlur,
  setFieldValue,
}: CountrySelectableProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const countryName = COUNTRIES.find((country) => country.CODE === value)?.NAME;
  const isUSA = value === "US";
  const [inputValue, setInputValue] = useState<string>(countryName ?? "");
  const onChange = async (changedOption: { value: CountryCode }) => {
    await setFieldValue("country", changedOption.value);
  };
  return (
    <EuiSelectable
      aria-label="Select country"
      options={[
        ...COUNTRIES.map((option) => ({
          value: option.CODE,
          label: option.NAME,
          // For US, allow "USA" to be searchable match
          searchableLabel: `${option.NAME} ${isUSA ? "USA" : option.CODE}`,
          checked: option.CODE === value ? ("on" as const) : undefined,
        })),
      ]}
      onChange={(newOptions, event, changedOption) => {
        if (changedOption.checked === "on") {
          setInputValue(changedOption.label);
          void onChange(changedOption);
        }
        setIsOpen(false);
      }}
      singleSelection
      searchable
      searchProps={{
        placeholder: "Please select your country",
        value: inputValue,
        onChange: (value) => {
          setInputValue(value);
        },
        onBlur: handleBlur,
        onKeyDown: (event) => {
          if (event.key === "Tab") return setIsOpen(false);
          if (event.key !== "Escape") return setIsOpen(true);
        },
        onClick: () => setIsOpen(true),
        onFocus: () => setIsOpen(true),
      }}
      listProps={{
        style: { maxHeight: 400, overflow: "scroll" },
        isVirtualized: true,
      }}
    >
      {(list, search) => (
        <EuiInputPopover
          fullWidth
          closePopover={() => {
            setIsOpen(false);
            setInputValue(countryName ?? "");
          }}
          disableFocusTrap
          closeOnScroll
          isOpen={isOpen}
          input={search ?? ""}
          panelPaddingSize="none"
        >
          {list}
        </EuiInputPopover>
      )}
    </EuiSelectable>
  );
};
